import React, { Component } from 'react';
import Header from '../../Layouts/Header'
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import AuthApi from '../../Services/Authapi';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TableComponent from '../../Layouts/TableComponent';
import swal from 'sweetalert';
import TextField from "@material-ui/core/TextField";
import AuthCheckComponent from '../../Layouts/Token';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';

class JobList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            job: [],
            count: 0,
            searchQuery: "",
            pageStatus: false,
            suggestions: [],
            expandedProfiles: {},
            tableTh: [
                { id: 'Job Title', numeric: false, disablePadding: true, label: 'Job Title', sortable: true },
                { id: 'companyProfile', numeric: false, disablePadding: true, label: 'Company Profile', sortable: true },
                { id: 'created_at', numeric: false, disablePadding: true, label: 'Created On', sortable: true },
                { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false }
            ]
        }
        this.jobData = this.jobData.bind(this);
        this.removeJob = this.removeJob.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
        this.toggleProfileExpansion = this.toggleProfileExpansion.bind(this);
    }

    componentWillMount() {
        if (this.props && this.props.authToken === false) {
            // this.props.history.push('/login');
        }
        this.jobData();
    }

    componentWillReceiveProps(props) {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    }

    jobData = async (e) => {
        let jobs = await AuthApi.getAllJob();

        if (jobs && jobs.status === true) {
            this.setState({
                job: jobs.data,
                count: jobs.data.length,
            })
        }
    }

    async removeJob(id) {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: ["Cancel", "Yes"]
        }).then(async (confirm) => {
            if (confirm) {
                let currentEvent = await AuthApi.deletejob(id);
                if (currentEvent && currentEvent.status === true) {
                    this.setState({
                        pageStatus: true
                    })
                    this.jobData();
                    setTimeout(
                        () => this.setState({ pageStatus: false }),
                        500
                    );
                } else {
                }
            }
        });
    }

    handleChange(e) {
        const searchQuery = e.target.value;
        const suggestions = this.state.job.filter((item) => {
            return (
                item.jobTitle.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.companyProfile.toLowerCase().includes(searchQuery.toLowerCase())
            );
        });
        this.setState({ searchQuery, suggestions });
    }

    handleSearch = () => {
        // Trigger search functionality
        const filterUser = this.state.job.filter((item) => {
            return (
                item.jobTitle.toLowerCase().includes(this.state.searchQuery.toLowerCase()) ||
                item.companyProfile.toLowerCase().includes(this.state.searchQuery.toLowerCase())
            );
        });
        this.setState({ filterUser });
    };

    clearSearch = () => {
        this.setState({ searchQuery: "", suggestions: [] }, this.handleSearch);
    };

    handleSuggestionClick = (suggestion) => {
        this.setState({ searchQuery: suggestion.jobTitle, suggestions: [] }, this.handleSearch);
    };

    toggleProfileExpansion(jobId) {
        this.setState((prevState) => ({
            expandedProfiles: {
                ...prevState.expandedProfiles,
                [jobId]: !prevState.expandedProfiles[jobId],
            },
        }));
    }

    render() {
        const classes = this.props;
        const filterUser = this.state.filterUser || this.state.job;
        const permissions = (this.props.authUser && Array.isArray(this.props.authUser.userAccess)) ? this.props.authUser.userAccess : [];
        return (
            <div>
                <AuthCheckComponent authToken={this.props.authToken} />
                <Header
                    {...this.props}
                    authUser={this.props.authUser}
                    setAutUser={this.props.setAutUser}
                    component={
                        <div style={{ marginBottom: "11%" }}>
                            <Card className={classes.root} style={{ marginBottom: '3%' }}>
                                <CardContent>
                                    <Breadcrumb
                                        {...this.props}
                                        primaryPageName="Job-Portal"
                                        primaryPageLink="/job"
                                        isSecondaryPage={false}
                                        secondaryPageName="" />
                                </CardContent>
                            </Card>
                            <TextField
                                label="Search"
                                value={this.state.searchQuery}
                                onChange={this.handleChange}
                                style={{
                                    position: "absolute",
                                    right: "135px",
                                    marginTop: "21px"
                                }}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: this.state.searchQuery !== "",
                                    style: {
                                        color: '#1b6e95',
                                        transform: this.state.searchQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)', // Adjust this line
                                        transition: 'transform 0.2s ease-in-out'
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        backgroundColor: 'lightgray',
                                        borderRadius: '25px',
                                        height: "40px"
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {this.state.searchQuery && (
                                                <ClearIcon onClick={this.clearSearch} style={{ cursor: 'pointer' }} />
                                            )}
                                            <SearchIcon onClick={this.handleSearch} style={{ cursor: 'pointer' }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {this.state.searchQuery && this.state.suggestions.length > 0 && (
                                <Paper
                                    style={{
                                        position: 'absolute',
                                        right: '205px',
                                        marginTop: '62px',
                                        zIndex: 1,
                                        width: "207px",
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
                                    }}>
                                    {[...new Set(this.state.suggestions.map(suggestion => suggestion.jobTitle))].map((jobTitle, index) => (
                                        <MenuItem
                                            key={index}
                                            onClick={() => this.handleSuggestionClick({ jobTitle })}
                                            style={{
                                                padding: '10px 20px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {jobTitle}
                                        </MenuItem>
                                    ))}
                                </Paper>
                            )}
                            <TableComponent
                                {...this.props}
                                tableTh={this.state.tableTh}
                                tableData={filterUser.map((item) => ({
                                    ...item,
                                    companyProfile: (
                                        <div>
                                            {this.state.expandedProfiles[item.id] || item.companyProfile.length <= 50
                                                ? item.companyProfile
                                                : `${item.companyProfile.substring(0, 50)}...`}
                                            {item.companyProfile.length > 50 && (
                                                <span
                                                    onClick={() => this.toggleProfileExpansion(item.id)}
                                                    style={{ color: '#1b6e95', cursor: 'pointer', marginLeft: '5px', display: 'inline-block' }}
                                                >
                                                    {this.state.expandedProfiles[item.id] ? 'Read Less' : 'Read More'}
                                                </span>
                                            )}
                                        </div>
                                    ),
                                }))}
                                tableCount={filterUser.length}
                                tablePagestatus={this.state.pageStatus}
                                colNameToShow={['jobTitle', 'companyProfile', 'created_at']}
                                openPopUp={false}
                                removeRow={this.removeJob}
                                actionBtns={[permissions.includes("Job.Edit") && ('update'), permissions.includes("Job.Delete") && ('delete')]}
                                modelName={'Job-Portal'}
                                addRoute={'/job/add'}
                                updateRoute={'/job/edit'}
                                openPopUpUpdate={false}
                            />
                        </div>
                    } />
                <Footer {...this.props} />
            </div >
        )
    }
}

export default JobList;